/**
 * External dependencies
 */
import React, { useEffect, useState } from 'react';
import { Box, Text, Stack } from '@towersystems/towersystems-design-system';
import { connect } from 'react-redux';
import { get, map, set } from 'lodash';

/**
 * Internal dependencies
 */
import FormLabel from 'components/forms/form-label';
import FormTextInput from 'components/forms/form-text-input';
import FormSelect from 'components/forms/form-select';
import FormMultiCheckbox from 'components/forms/form-multi-checkbox';
import { editConnectionPaymentTypes, saveConnectionPaymentTypes } from 'state/connection-payment-types/actions';
import { getAllConnectionPaymentTypes } from 'state/connection-payment-types/selectors';

/**
 * Style dependencies
 */
import './styles.scss';

const PaymentTypesForm = ({ paymentTypeId, connectionPaymentTypes, retailerSalesTypes, retailerPaymentTypes, webPaymentTypes, connectionId, connectionType, disabled, ...props }) => {
    const handleOnChange = (name, value) => {
        // props.editConnectionPaymentTypes(paymentTypeId, {
        //     [name]: value,
        // });
        let a = {
			...values,
		};
		a[name] = value;
		setValues(a);

        props.editConnectionPaymentTypes(paymentTypeId, {
            [name]: value,
        });
    };

    const [values, setValues] = useState({
		web_payment_type: '',
        retailer_sales_type: '',
        retailer_payment_type: '',
	});


    const handleOnChangeDD= (e) => {
        let a = {
			...values,
		};
		a[e.target.name] = e.target.value;
		setValues(a);

        props.editConnectionPaymentTypes(paymentTypeId, {
            [e.target.name]: e.target.value,
        });
    };

    const handleOnSubmit = async (e) => {
        e.preventDefault();
        props.beforeSubmit && props.beforeSubmit(connectionPaymentTypes);

        let a = {
			...values,
		};

        a['connection_id'] = connectionId;
        a['web_payment_type'] = get(values, 'web_payment_type') ? get(values, 'web_payment_type') : (get(connectionPaymentTypes, 'web_payment_type'));
        a['retailer_sales_type'] = get(values, 'retailer_sales_type') ? get(values, 'retailer_sales_type') : (get(connectionPaymentTypes, 'retailer_sales_type'));
        a['retailer_payment_type'] = get(values, 'retailer_payment_type') ? get(values, 'retailer_payment_type') : (get(connectionPaymentTypes, 'retailer_payment_type'));

        try {
            let response = await props.saveConnectionPaymentTypes(paymentTypeId, a);
            props.afterSuccessfullSubmit && props.afterSuccessfullSubmit(response);
            // props.loadSalesTypesData(connectionId);
        } catch (error) {}

        props.afterSubmit && props.afterSubmit();
    };

    const isShown = disabled ? 'none' : 'block';

    return (
        <form id='payment-type-form' onSubmit={handleOnSubmit}>
            <Stack space='large'>
                <Box>
                    <FormLabel>Web Payment Type:</FormLabel>
                    <Text size='xsmall'>Web Payment Type.</Text>
                    <FormTextInput
                        name='web_payment_type'
                        value={get(values, 'web_payment_type') ? get(values, 'web_payment_type') : get(connectionPaymentTypes, 'web_payment_type')}
                        onChange={(e) => handleOnChange(e.target.name, e.target.value)}
                    />
                </Box>
                
                <Box>
                    <FormLabel>Status:</FormLabel>
                    <Text size='xsmall'>
                    Payment Method Status
                    </Text>
                    <Box marginTop='medium'>
                        <FormSelect
                            onChange={handleOnChangeDD}
                            name='retailer_payment_type'             
                            value={get(values, 'retailer_payment_type') ? get(values, 'retailer_payment_type') : (get(connectionPaymentTypes, 'retailer_payment_type'))}
                        >
                            <option value='' />,
                            {map(retailerPaymentTypes, (retailerPaymentType) => (
                                <option value={retailerPaymentType.pay_name} key={retailerPaymentType.id}>
                                    {retailerPaymentType.pay_name}
                                </option> : ''
                            ))}

                        </FormSelect>
                    </Box>
                </Box>
            </Stack>
        </form>
    );
};

export default connect(
    (state, ownProps) => ({
        //connectionPaymentTypes: getAllConnectionPaymentTypes(state),
    }),
    {
        editConnectionPaymentTypes,
        saveConnectionPaymentTypes,
    },
)(PaymentTypesForm);
